import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const DATE_FORMAT = 'YYYY-MM-DD'

export const backendDateFromStringDate = (dateString: string | null): Date | null => {
  if (!dateString) {
    return null
  }

  return dayjs(dateString, DATE_FORMAT).toDate()
}

export const stringDateFromBackendDate = (date: Date | null): string | null => {
  if (!date) {
    return null
  }

  return dayjs.utc(date).format(DATE_FORMAT)
}
